jQuery(document).ready(function($){
	var wid = window.innerWidth;

        $(function(){
            $('#loading').addClass('-is-active');
        });

	/*==================================================
	スムーススクロール
	==================================================*/
	// #で始まるリンクをクリックしたら実行されます
	var headerHeight = $('header').outerHeight();
	var urlHash = location.hash;
	$('a[href^="#"]').click(function() {
        var href= $(this).attr("href");
        var match = href.match("^#(recover$|login$)$");
        if(!match){
    		// スクロールの速度
    		var speed = 400; // ミリ秒で記述
    		var target = $(href == "#" || href == "" ? 'html' : href);
    		var position = target.offset().top - headerHeight;
    		$('body,html').animate({scrollTop:position}, speed, 'swing');
    		return false; 
        }
	});
	if(urlHash) {
		$('body,html').stop().scrollTop(0);
		setTimeout(function(){
			var target = $(urlHash);
			var position = target.offset().top - headerHeight;
			$('body,html').stop().animate({scrollTop:position}, 400);
		}, 100);
	}
  });

	/*==================================================
	gnav
	==================================================*/
	var menu = $('#gnav'), // Fetch menu to fade in
		menuBtn = $('#menuBtn'), // Fetch menu button
		body = $(document.body);

	menuBtn.on('click', function(){
		_menuBtn();
	});
    $('.gnavBg').on('click', function(){
		_removeMenu();
	});

	function _menuBtn(){
		body.toggleClass('opened');
		menuBtn.toggleClass('opened');
		menu.toggleClass('opened');
	}
	function _removeMenu(){
		body.removeClass('opened');
		menuBtn.removeClass('opened');
		menu.removeClass('opened');
	}

	/*==================================================
    animation
    ==================================================*/
    //ロードしたときに既にanimationの要素が入る場合はすぐに-is-activeのクラスをつける
    $(".animation").each(function () {
        var position = $(this).offset().top;
        var windowHeight = $(window).height();
        if(position < windowHeight){
            $(this).addClass("-is-active");
        }
    });
    //スライド時にanimationの要素が入ったら-is-activeのクラスをつける
    $(window).on('scroll resize load', function () {
      _removeMenu();
		var wid = window.innerWidth;
        $(".animation").each(function () {
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
			if(wid <= 768){
				var plus = windowHeight * 0.1;
			}else{
				var plus = windowHeight * 0.3;
			}
            if(scroll > position - windowHeight + plus){
                $(this).addClass("-is-active");
            }
        });
    });

const swiper3 = new Swiper('.swiper-collection-slider-container', {
    direction: 'horizontal',
    loopedSlides: 6,
    spaceBetween: 10,
    slidesPerView: 2.2,
    navigation: {
        nextEl: '.swiper-svg-next',
        prevEl: '.swiper-svg-prev'
    },
    breakpoints: {
        759: {
            slidesPerView: 3.2,
            centeredSlides: false,
            spaceBetween: 30,
        },
        989: {
            slidesPerView: 4.2,
            centeredSlides: false,
            spaceBetween: 30,
        },
    },
});

/* ここらへんなんかややこしいけど、同じスライダーが複数使われたときにナビゲーションで一緒に動いちゃわないようにするコードです */
const swiperPrev = document.getElementsByClassName('swiper-button-prev-pretend');
const swiperNext = document.getElementsByClassName('swiper-button-next-pretend');

for (let i = 0; i < swiperPrev.length; i++) {
    swiperPrev[i].addEventListener('click', (e) => {
        const parent = e.target.parentNode;
        const prev = parent.getElementsByClassName('swiper-button-prev')[0];
        prev.click();
    });
}


for (let i = 0; i < swiperNext.length; i++) {
    swiperNext[i].addEventListener('click', (e) => {
        const parent = e.target.parentNode;
        const next = parent.getElementsByClassName('swiper-button-next')[0];
        next.click();
    });
}